import { createFileRoute } from '@tanstack/react-router'
import { FlyerTool } from '~/features/ai-studio/components'

export const Route = createFileRoute('/dashboard/ai-studio/flyer')({
  component: FlyerTool,
})
